import axios from "axios";
import secureLocalStorage from "react-secure-storage";

// Create axios instance without static auth token
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  // baseURL: `https://backend.planit.pk/api/v1/`,
  // baseURL: `http://localhost:5026/api/v1/`,
  timeout: 500000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Add request interceptor to dynamically set auth token on every request
instance.interceptors.request.use(
  (config) => {
    // Read auth token from localStorage on every request
    const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo")) || {};

    if (adminInfo) {
      try {
        const parsedInfo = adminInfo;
        if (parsedInfo.authToken) {
          config.headers.authToken = parsedInfo.authToken;
        }
      } catch (error) {
        console.error("Error parsing adminInfo:", error);
      }
    }

    // For FormData, remove Content-Type so browser sets it with the correct multipart boundary
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle global errors (like 401)
instance.interceptors.response.use(
  (response) => {
    // Check if the response itself contains the "Un-Athunticated" message
    if (response.data === "Un-Athunticated request" || response.data?.data === "Un-Athunticated request") {
      console.log("Unauthorized! Logging out...");
      // 🛑 Safe Logout (Inline to avoid circular dependency)
      secureLocalStorage.removeItem("adminInfo");
      secureLocalStorage.removeItem("admins");
      secureLocalStorage.removeItem("loginTime");
      secureLocalStorage.removeItem("sessionTimeoutMins");

      window.location.href = "/";
      return Promise.reject(new Error("Session expired"));
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized! Logging out...");
      // 🛑 Safe Logout (Inline to avoid circular dependency)
      secureLocalStorage.removeItem("adminInfo");
      secureLocalStorage.removeItem("admins");
      secureLocalStorage.removeItem("loginTime");
      secureLocalStorage.removeItem("sessionTimeoutMins");

      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

const responseBody = (response) => response.data;

const requests = {
  get: (url, body) => instance.get(url, body).then(responseBody),

  post: (url, body, headers) => instance.post(url, body, headers).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url) => instance.delete(url).then(responseBody),
};

export default requests;
